export default "__VITE_ASSET__Cns6U2z7__"